import React from 'react'
import { Base, ChevronIcon } from '@itsrever/design-system'
import { useTranslation } from 'react-i18next'

const {
  Button,
  MenuRoot,
  MenuTrigger,
  MenuPortal,
  MenuPositioner,
  MenuPopup,
  MenuRadioGroup,
  MenuRadioItem
} = Base

interface CopySelectorProps {
  copies: { key: string; text: string }[]
  selectedCopy: string
  onChange: (copyCode: string) => void
}

export const CopySelector: React.FC<CopySelectorProps> = ({
  copies,
  selectedCopy,
  onChange
}) => {
  const { t } = useTranslation()
  const selectedText =
    copies.find((copy) => copy.key === selectedCopy)?.text ?? ''

  return (
    <MenuRoot>
      <MenuTrigger render={<Button variant="secondary" className="w-full" />}>
        <span className="truncate">
          {t('custom_copies.copies_titles.' + selectedText)}
        </span>
        <ChevronIcon className="shrink-0" />
      </MenuTrigger>
      <MenuPortal>
        <MenuPositioner sideOffset={6} align="start">
          <MenuPopup className="max-h-[var(--available-height)] overflow-y-auto">
            <MenuRadioGroup
              value={selectedCopy}
              onValueChange={(copyCode: string) => onChange(copyCode)}
            >
              {copies.map((copy) => (
                <MenuRadioItem key={copy.key} value={copy.key}>
                  {t('custom_copies.copies_titles.' + copy.text)}
                </MenuRadioItem>
              ))}
            </MenuRadioGroup>
          </MenuPopup>
        </MenuPositioner>
      </MenuPortal>
    </MenuRoot>
  )
}

export default CopySelector
